import React, { useEffect, useState } from "react";
import axios from "axios";

const ContactList = () => {
  const [contact, setcontact] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);

  const fetchcontact = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/contact`);

      // response.data should be an array like the one you sent
      setcontact(response.data);
    } catch (error) {
      console.error("Error fetching contact", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchcontact();
  }, []);

  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <h2 className="td_section_title td_fs_48">List of Contact</h2>

          <div className="td_height_30 td_height_lg_30" />

          <div className="td_table_1 mb-5">
            <div className="table-responsive">
              <table>
                <thead>
                  <tr className="td_accent_bg">
                    <th className="td_white_color td_bold">SN</th>
                    <th className="td_white_color td_bold">Full Name</th>
                    <th className="td_white_color td_bold">Email</th>
                    <th className="td_white_color td_bold">Mobile</th>
                    <th className="td_white_color td_bold">Address</th>
                    <th className="td_white_color td_bold">Message</th>
                    <th className="td_white_color td_bold">
                      Contacted At
                    </th>{" "}
                    {/* <th className="td_white_color td_bold">Action</th> */}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={7} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : contact.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No contact found
                      </td>
                    </tr>
                  ) : (
                    contact.map((app, index) => (
                      <tr key={app.id}>
                        <td>{index + 1}</td>
                        <td>{app.name}</td>
                        <td>{app.email}</td>
                        <td>{app.mobile}</td>
                        <td>{app.address}</td>
                        <td>{app.textMessage}</td>
                        <td>{new Date(app.createdAt).toLocaleString()}</td>{" "}
                        {/* Applied At */}
                        {/* Action - View Button */}
                        {/* <td>
                          <Link to={`/contact/${app.id}`}>
                            <button className="td_table_close_btn">
                              <i className="fa-solid fa-eye"></i>
                            </button>
                          </Link>
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactList;
